var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('section',[_c('Title',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.category.title))]),_c('div',{staticClass:"article-widget-list d-flex flex-column"},_vm._l((_vm.items),function(ref,i){
var id = ref.id;
var title = ref.title;
var img = ref.img;
var category = ref.category;
var date = ref.date;
return _c('ArticleCard',{key:i,attrs:{"id":id,"title":title,"img":img,"date":date,"category-title":category.title,"category-color":category.color,"type":i === 0 ? 'featured' : 'small'}})}),1)],1):_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }